import { CoreCard, coreToast } from "@verity/components/core";
import { useEffect, useState } from "react";
import i18n from "../../../../i18n";
import { baseTransKey } from "./verityAssessmentHelper";
import { VerityAssessment } from "@verity/api-client/types";
import apiClient from "../../../../helpers/api-client";
import styles from "./index.module.css";
import { QuizWithProctoringOptions } from "../assessments-page-helper";
import VerityAssessmentSection from ".";

type EditVerityAssessmentSectionProps = {
	assessment: QuizWithProctoringOptions;
	onFinish: () => void;
};

export default function EditVerityAssessmentSection({ assessment, onFinish }: EditVerityAssessmentSectionProps) {
	const [loadingAssessment, setLoadingAssessment] = useState(true);
	const [verityAssessment, setVerityAssessment] = useState<VerityAssessment | null>(null);

	useEffect(() => {
		void (async () => {
			try {
				setLoadingAssessment(true);
				const result = await apiClient.assessment.getVerityAssessmentInstructor(assessment.id);
				setVerityAssessment(result ?? null);
			} catch (e) {
				console.error(e);
				coreToast.error(i18n.t(`${baseTransKey}.errorToast.DB_FAIL`) as string, { autoClose: 2500 });
			} finally {
				setLoadingAssessment(false);
			}
		})();
	}, [assessment.id]);

	if (loadingAssessment) {
		return (
			<div className={styles.verityAssessmentSection}>
				<div className={styles.scrollWrapper}>
					<CoreCard style={{ height: "65px" }} />
				</div>
			</div>
		);
	}

	if (!verityAssessment) {
		return null;
	}

	return (
		<VerityAssessmentSection
			key={assessment.id}
			assessment={assessment}
			verityAssessment={verityAssessment}
			onFinish={onFinish}
		/>
	);
}
